export enum PauseAutomationFormat {
  MINUTES = 'minutes',
  HOURS = 'hours',
}
